const RealLifeStories = (): JSX.Element => (
  <svg
    width="23px"
    height="23px"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.513 11.563a1.083 1.083 0 0 0-1.604-1.456l-3.755 4.137-2.105-2.063a1.083 1.083 0 1 0-1.517 1.547l3.713 3.64 5.268-5.805Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.848.04A4.333 4.333 0 0 0 .515 4.371v13.255a4.333 4.333 0 0 0 4.333 4.333h10.304a4.333 4.333 0 0 0 4.333-4.333V6.489c0-.806-.3-1.583-.84-2.181l-2.895-3.2A3.25 3.25 0 0 0 13.34.04H4.848Zm0 19.97h10.304a2.383 2.383 0 0 0 2.383-2.383V7.367h-5.283V1.989H4.848a2.383 2.383 0 0 0-2.383 2.383v13.255a2.383 2.383 0 0 0 2.383 2.383ZM17.2 5.616l.015.017h-3.229V2.16a1.3 1.3 0 0 1 .32.257l2.894 3.2Z"
      fill="currentColor"
    />
  </svg>
);

export default RealLifeStories;
